
class BundleBuilder extends HTMLElement {
  constructor() {
    super();
  }

  loadContent() {
  }

  setupModelViewerUI(errors) {
  }
}

customElements.define('bundle-builder', BundleBuilder);

class BundleComponents extends HTMLElement {
  constructor() {
    super();
    this.bundleBuilder = document.querySelector("bundle-builder");
    this.bundleRadios = this.bundleBuilder.querySelector("bundle-radios");
    this.bundleForm = this.bundleBuilder.querySelector("bundle-form");
    this.bundleQuantity = 0;
    this.selectedComponents = [];
  }

  renderComponents() {
    const bundleInfo = this.bundleRadios.getVariantHiddenData();
    let productsHtml = "";
    for (const bundle of bundleInfo) {
      if (bundle.id === this.bundleRadios.currentVariant.id) {
        this.bundleQuantity = bundle.bundle_quantity;

        for (const bundleProduct of bundle.bundle_products) {
          let variantsHtml = "";
          for (const bundleVariant of bundleProduct.variants) {
            const variant = `
              <div class="bundle-components--product-variant ${bundleVariant.available ? "" : "sold"}" ${bundleVariant.available ? "data-bundle-component-available" : ""} data-bundle-component-id="${bundleVariant.id}" data-bundle-component-title="${bundleVariant.title}" data-bundle-component-size="${bundleVariant.size}" data-bundle-component-image="${bundleVariant.image}">
                <div class="bundle-components--product-variant--title">
                  ${bundleVariant.title}
                </div>
                <div class="bundle-components--product-variant--image">
                  <img src="${bundleVariant.image}" height="60px" width="80px" alt="BundleVariantImage-${bundleVariant.title}">
                </div>
                ${bundleVariant.available ? `
                  <div class="bundle-components--product-variant--add">

                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="7" cy="7" r="6.25" fill="none" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M7 9.82842V4.17157" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M4.17152 7L9.82837 7" stroke="currentColor" stroke-width="1.5"/>
                    </svg>

                  </div>` :
                  '<div class="bundle-components--product-variant--sold">Out of Stock</div>'
                }
              </div>
            `;
            variantsHtml += variant;
          }

          const bundleProductDescription = bundleProduct.description !== "" ? `<div class="bundle-components--product-description--wrapper"><p><span>${bundleProduct.description}</span></p></div>` : "";

          const product = `
            <div class="bundle-components--product">
              <div class="bundle-components--product-title--wrapper">
                <div class="bundle-components--product-title">
                  <h3>${bundleProduct.title}</h3>
                </div>
                <div class="bundle-components--reviews">
                  <div class="bundle-components--reviews-stars">
                    ${this.dataset.reviewsSvg}
                  </div>
                  <p class="bundle-components--reviews-text-wrapper">
                    <span>
                      ${bundleProduct.reviewsValue}
                    </span>
                    (${bundleProduct.reviewsCount})
                  </p>
                </div>
              </div>
              ${bundleProductDescription !== "" ? bundleProductDescription : ""}
              <div class="bundle-components--product-variants">
                ${variantsHtml}
              </div>
            </div>
          `;
          productsHtml += product;
        }
      }
    }

    this.bundleRadios.toggleAddButton(true, `SELECT ${this.bundleQuantity} BAGS`, true);
    this.selectedComponents = {};
    this.innerHTML = `
      <div class="bundle-components--products">
        ${productsHtml}
      </div>
    `;

    this.bundleForm.emptyBundleFormComponents(this.bundleQuantity);
    this.updateComponentsEvents();
  }

  updateComponentsEvents() {
    const bundleComponents = this.querySelectorAll("[data-bundle-component-available]");
    bundleComponents.forEach((bundleComponent) => {
      bundleComponent.addEventListener("click", () => {
        const bundleComponentSize = parseInt(bundleComponent.dataset.bundleComponentSize);
        const currentTotalSize = Object.values(this.selectedComponents).reduce((total, component) => {
          return total + component.size;
        }, bundleComponentSize);
        if (currentTotalSize > this.bundleQuantity)
          return;
        const emptySlots = this.bundleForm.querySelectorAll("[data-form-components-empty]");
        let removeIndexes = [];
        for (let index = 0; index < bundleComponentSize; index++) {
          removeIndexes.push(emptySlots[index].dataset.index);
          let newBundleComponent = `
            <div class="product-form__components-item" data-remove-component-index=${emptySlots[index].dataset.index}>
              <div class="product-form__components-item--image">
                <img src="${bundleComponent.dataset.bundleComponentImage}" height="60px" width="80px" alt="BundleVariantImage-${bundleComponent.dataset.bundleComponentTitle}">
              </div>
              <div class="product-form__components-item--title">
                ${bundleComponent.dataset.bundleComponentTitle}
              </div>`;
          if (index === bundleComponentSize - 1)
            newBundleComponent += `
              <div class="product-form__components-item--remove" data-index=${emptySlots[index].dataset.index} data-remove-size="${bundleComponentSize}" data-remove-id="${bundleComponent.dataset.bundleComponentId}">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="7" cy="7" r="6.25" transform="rotate(90 7 7)" fill="white" stroke="#00B3E4" stroke-width="1.5"/>
                  <path d="M9 9L5 5" stroke="#00B3E4" stroke-width="1.5"/>
                  <path d="M4.99988 9L8.99988 5" stroke="#00B3E4" stroke-width="1.5"/>
                </svg>

              </div>
            `;
          newBundleComponent += "</div>";
          emptySlots[index].outerHTML = newBundleComponent;
        }

        this.selectedComponents[emptySlots[bundleComponentSize - 1].dataset.index] = {
          id: bundleComponent.dataset.bundleComponentId,
          title: bundleComponent.dataset.bundleComponentTitle,
          size: parseInt(bundleComponent.dataset.bundleComponentSize)
        };
        this.bundleForm.bundleSubmitComponentsId.value = Object.values(this.selectedComponents).map(component => component.id).join(', ');
        this.bundleForm.bundleSubmitComponentsTitle.value = Object.values(this.selectedComponents).map(component => component.title).join(', ');
        const totalSize = Object.values(this.selectedComponents).reduce((total, component) => {
          return total + component.size;
        }, 0);
        if (totalSize === this.bundleQuantity)
          this.bundleRadios.toggleAddButton(false, `ADD TO CART`, true);
        else
          this.bundleRadios.toggleAddButton(true, `SELECT ${this.bundleQuantity - totalSize} MORE BAGS`, true);

        const removeSelectedComponent = this.bundleForm.querySelector(`[data-remove-component-index="${emptySlots[bundleComponentSize - 1].dataset.index}"]`);
        const removeSelectedComponentButton = removeSelectedComponent.querySelector(`[data-remove-id]`);
        removeSelectedComponentButton.addEventListener("click", () => {
          for (const removeIndex of removeIndexes) {
            const removeComponent = this.bundleForm.querySelector(`[data-remove-component-index="${removeIndex}"]`);
            removeComponent.outerHTML = `
              <div class="product-form__components-empty" data-form-components-empty data-index=${removeIndex}><span>Bag ${+removeIndex + 1}</span></div>
            `;
          }

          delete this.selectedComponents[removeSelectedComponent.dataset.removeComponentIndex];
          this.bundleForm.bundleSubmitComponentsId.value = Object.values(this.selectedComponents).map(component => component.id).join(', ');
          this.bundleForm.bundleSubmitComponentsTitle.value = Object.values(this.selectedComponents).map(component => component.title).join(', ');
          const totalSize = Object.values(this.selectedComponents).reduce((total, component) => {
            return total + component.size;
          }, 0);
          if (totalSize === 0)
            this.bundleRadios.toggleAddButton(true, `SELECT ${this.bundleQuantity} BAGS`, true);
          else
            this.bundleRadios.toggleAddButton(true, `SELECT ${this.bundleQuantity - totalSize} MORE BAGS`, true);
        });
      });
    });
  }
}

class BundleRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.updateOptions();
    this.updateMasterId();
    this.bundleBuilder = document.querySelector("bundle-builder");
    this.bundleComponents = this.bundleBuilder.querySelector("bundle-components");
    this.bundleComponents.renderComponents();
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.bundleComponents.renderComponents();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      let option = inputs.find((radio) => radio.checked);
      if (!option)
        option = inputs[0];
      return option.value;
    });
  }

  updateMasterId() {
    const hiddenVariantsMap = this.getVariantHiddenData();
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    let currentVariantHidden = false;
    for (const variant of hiddenVariantsMap) {
      if (currentVariantHidden && !variant.hidden) {
        this.currentVariant = this.variantData.find((v) => v.id === variant.id);
        break;
      }

      if (variant.id === this.currentVariant.id) {
        if (!variant.hidden)
          break
        else
          currentVariantHidden = true;
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
      });
  }

  renderSizeSelects(html) {
    const destination = document.querySelector(`[data-size-options]`);
    const source = html.querySelector(`[data-size-options]`);
    if (source && destination) destination.innerHTML = source.innerHTML;

    destination.dispatchEvent(new Event('size-options-change', { bubbles: true }));
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[type="submit"]');
    const addButtonText = productForm.querySelector('[type="submit"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (text)
        addButtonText.textContent = text;
      else
        addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('#json-product-variants').textContent);
    return this.variantData;
  }

  getVariantHiddenData() {
    this.variantHiddenData = this.variantHiddenData || JSON.parse(this.querySelector('#json-product-variants-hidden').textContent);
    return this.variantHiddenData;
  }
}

class BundleForm extends HTMLElement {
  constructor() {
    super();

    this.bundleBuilder = document.querySelector("bundle-builder");
    this.bundleRadios = this.bundleBuilder.querySelector("bundle-radios");
    this.bundleSubmitComponentsId = this.querySelector("[data-product-form-components-id]");
    this.bundleSubmitComponentsTitle = this.querySelector("[data-product-form-components-title]");

    this.form = this.querySelector('form');
    this.bundleComponents = this.querySelector('[data-form-components]');
    this.bundlePrice = this.querySelector('[data-product-form-price]');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');
    if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (this.dataset.cartType != 'page') {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    const values = this.bundleSubmitComponentsId.value.split(", ");
    const valuesJson = [];
    values.forEach(value => {
      valuesJson.push({ id: value, quantity: 1});
    });


    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: valuesJson
      })
    }).then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (this.dataset.cartType == 'page') {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });

    // fetch(`${routes.cart_add_url}`, config)
    //   .then((response) => response.json())
    //   .then((response) => {
    //     if (response.status) {
    //       this.handleErrorMessage(response.description);

    //       const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
    //       if (!soldOutMessage) return;
    //       this.submitButton.setAttribute('aria-disabled', true);
    //       this.submitButton.querySelector('span').classList.add('hidden');
    //       soldOutMessage.classList.remove('hidden');
    //       this.error = true;
    //       return;
    //     } else if (this.dataset.cartType == 'page') {
    //       window.location = window.routes.cart_url;
    //       return;
    //     }

    //     this.error = false;
    //     const quickAddModal = this.closest('quick-add-modal');
    //     if (quickAddModal) {
    //       document.body.addEventListener('modalClosed', () => {
    //         setTimeout(() => { this.cart.renderContents(response) });
    //       }, { once: true });
    //       quickAddModal.hide(true);
    //     } else {
    //       this.cart.renderContents(response);
    //     }
    //   })
    //   .catch((e) => {
    //     console.error(e);
    //   })
    //   .finally(() => {
    //     this.submitButton.classList.remove('loading');
    //     if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    //     if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    //     this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    //   });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  emptyBundleFormComponents(quantity) {
    let bundleFormComponent = "";
    for (let index = 0; index < quantity; index++) {
      bundleFormComponent += `
        <div class="product-form__components-empty" data-form-components-empty data-index=${index}><span>Bag ${index + 1}</span></div>
      `
    }
    this.bundleComponents.innerHTML = bundleFormComponent;
  }
}

customElements.define('bundle-components', BundleComponents);

customElements.define('bundle-form', BundleForm);

customElements.define('bundle-radios', BundleRadios);

